import { render, staticRenderFns } from "./carLoss.vue?vue&type=template&id=432a8ddc&scoped=true"
import script from "./carLoss.vue?vue&type=script&lang=js"
export * from "./carLoss.vue?vue&type=script&lang=js"
import style0 from "./carLoss.vue?vue&type=style&index=0&id=432a8ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a8ddc",
  null
  
)

export default component.exports